import React from "react";
import { Link } from "gatsby";
import tw, { styled } from "twin.macro";
import "styled-components/macro";
import _ from "lodash";
import { titleCase } from "../utils";
import moment from "moment-timezone";

import DynamicContainer from "./DynamicContainer";

const Container = styled(DynamicContainer)`
  ${tw`
    py-2 sm:py-4
    flex items-end
    bg-transparent
  `}
`;

const Content = styled.div`
  ${tw`
    flex grow items-center justify-between gap-16
  `}
`;

const LeftContainer = styled.div`
  ${tw`text-xs text-gray-400`}
`;

const StyledLink = styled(Link)`
  ${tw`
    no-underline uppercase
    text-black font-medium 
    // [&:last-of-type]:text-gray-400
  `}
`;

const StyledSpan = styled.span`
  ${tw`
  no-underline uppercase
  font-medium text-gray-400
`}
`;

const PageTitle = styled.h6`
  ${tw`font-semibold text-right`}
`;

const EXCEPTIONS = {
  schedule: { prependColon: false },
  roster: { prependColon: false },
  category: { prependColon: true },
  author: { prependColon: true },
  directions: { prependColon: true },
  team: { prependColon: true },
};

const Breadcrumbs = ({
  location,
  seoTitle,
  pageTitle,
  useSeoForTitle,
  site,
  suffix,
}) => {
  const locationArr = _.get(location, "pathname", "")
    .split("/")
    .filter((path) => !_.isEmpty(path));

  let exceptionRoutes = Object.keys(EXCEPTIONS).filter((route) =>
    site === "academy" && route === "roster" ? false : true
  );

  const exception = _.first(_.intersection(locationArr, exceptionRoutes));
  const exceptionIdx = _.indexOf(locationArr, exception);
  const hasException = exceptionIdx > -1;

  let pathname = "/";
  return (
    <Container>
      <Content>
        <LeftContainer>
          {!_.isEmpty(locationArr) && (
            <>
              <StyledLink to="/">Home</StyledLink>
              {locationArr.map((item, idx) => {
                pathname += item + "/";
                if (hasException && idx === exceptionIdx + 1) {
                  item = `${exception}${
                    _.get(EXCEPTIONS, [exception, "prependColon"]) ? ":" : ""
                  } ${item}`;
                }
                const itemLabel = item.replaceAll("-", " ").trim();

                if (exception === item) return null;
                return (
                  <React.Fragment key={idx}>
                    <span tw="mx-1">/</span>
                    {idx < locationArr.length - 1 ? (
                      <StyledLink to={pathname}>{itemLabel}</StyledLink>
                    ) : (
                      <StyledSpan>
                        {useSeoForTitle ? seoTitle : itemLabel}
                      </StyledSpan>
                    )}
                  </React.Fragment>
                );
              })}
            </>
          )}
          {suffix && (
            <>
              <span tw="mx-1">/</span>
              <StyledSpan>{suffix}</StyledSpan>
            </>
          )}
        </LeftContainer>
      </Content>
    </Container>
  );
};

export default Breadcrumbs;
